import { Injectable } from '@angular/core';

import { ControlSpecification } from '../types/specification.types';
import { AbstractControl, ControlLayoutModel, LayoutControlContainer } from '../types/control.types';
import { ControlTypeName } from '../types/control-type-name';

import { AbstractToolService } from './abstract-tool.service';
import { DesignerConfigurationService } from '../services/designer-configuration.service';
import { translateControlSpecitification2LayoutModel } from '../utils/control-translate';

@Injectable({
  providedIn: 'root'
})
export class DragDrawToolService extends AbstractToolService {
  specification: ControlSpecification;

  controlLayers: { type: string; specification?: ControlSpecification }[] = [
    { type: ControlTypeName.container },
    { type: ControlTypeName.row },
    { type: ControlTypeName.cell }
  ];

  constructor(private configuration: DesignerConfigurationService) {
    super();
    this.controlLayers.forEach((s) => {
      s.specification = this.getControlSpecification(s.type);
    });
  }

  start(specification: ControlSpecification) {
    this.specification = specification;
  }

  do(host: LayoutControlContainer, args: any) {
    if (host.control.isContainer) {
      const layoutModel = this.getDrawLayoutModel(host.control);
      if (host.control.addControl) {
        host.control.addControl(layoutModel);
      }
    }
  }
  private getDrawLayoutModel(hostControl: AbstractControl<any>): ControlLayoutModel {
    // æ¯å®¹å¨æ§ä»¶ ç´æ¥è¿å
    if (this.controlLayers.findIndex((s) => s.specification.name === this.specification.name) > -1) {
      return this.getLayoutModel(this.specification);
    }
    // æ¯å®¹å¨çæåä¸å±ï¼ç´æ¥è¿å
    const index = this.controlLayers.findIndex((s) => s.type === hostControl.type);
    if (index === this.controlLayers.length - 1) {
      return this.getLayoutModel(this.specification);
    }
    // å¾ªç¯å¢å layoutmodelçchildren
    const layoutModel: ControlLayoutModel = this.getLayoutModel(this.controlLayers[index + 1].specification);

    layoutModel.children = [];
    let children = layoutModel.children;

    for (let i = index + 2; i < this.controlLayers.length; i++) {
      const child = this.getLayoutModel(this.controlLayers[i].specification);
      child.children = [];
      children.push(child);
      children = child.children;
    }
    children.push(this.getLayoutModel(this.specification));
    return layoutModel;
  }

  private getLayoutModel(specification: ControlSpecification) {
    return translateControlSpecitification2LayoutModel(specification);
  }

  private getControlSpecification(type: string) {
    return this.configuration.findControlSpecification(type);
  }
}
